<template>
  <modal
    name="registration-form"
    class="reg-modal registration-modal"
    width="500px"
    height="560px"
    :adaptive="true"
    :clickToClose="false"
  >
    <div class="reg step-box">
      <form id="formReg" action="regUrl" class="reg-form" method="post">
        <button @click.prevent="hideForm()" class="pz-close-btn">
          <svg
            id="Capa_1"
            enable-background="new 0 0 413.348 413.348"
            height="512"
            viewBox="0 0 413.348 413.348"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"
            />
          </svg>
        </button>

        <div class="reg-form__header">Регистрация</div>
        <div class="input-wrapper">
          <input
            :class="{ hasError: this.loginError }"
            :value="login"
            @input="updateLogin"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[name]"
            placeholder="Фамилия Имя Отчество"
            type="text"
            :disabled="this.isRequested"
          />
          <span class="input-error" v-if="this.loginError">{{
            this.loginError
          }}</span>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.emailError }"
            :value="email"
            @input="updateEmail"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[email]"
            placeholder="Электронная почта"
            type="text"
            :disabled="this.isRequested"
          />
          <div v-if="this.emailError">
            <p class="input-error" v-html="emailError"></p>
          </div>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.phoneError }"
            :value="phone"
            @input="updatePhone"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[phone]"
            placeholder="Телефон в формате +7 (123) 456-78-90"
            type="text"
            v-mask="
              setting.currency === '₽'
                ? '+7 (###) ###-##-##'
                : '+375 (##) ###-##-##'
            "
            :disabled="this.isRequested"
          />
          <div v-if="this.phoneError">
            <p class="input-error" v-html="phoneError"></p>
          </div>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.birthdayError }"
            :value="birthday"
            @input="updateBirthday"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[birthday]"
            placeholder="Дата рождения в формате дд.мм.гггг"
            type="text"
            v-mask="'##.##.####'"
            :disabled="this.isRequested"
          />
          <div v-if="this.birthdayError">
            <p class="input-error" v-html="birthdayError"></p>
          </div>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.passwordError }"
            :value="password"
            @input="updatePassword"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[password]"
            placeholder="Пароль"
            type="password"
            :disabled="this.isRequested"
          />
          <span class="input-error" v-if="this.passwordError">{{
            this.passwordError
          }}</span>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.repeatPasswordError }"
            :value="repeatPassword"
            @input="updateRepeatPassword"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[passwordRepeat]"
            placeholder="Повторите пароль"
            type="password"
            :disabled="this.isRequested"
          />
          <span class="input-error" v-if="this.repeatPasswordError">{{
            this.repeatPasswordError
          }}</span>
        </div>

        <div class="input-wrapper gender">
          Укажите ваш пол:

          <input
            type="radio"
            id="rbMale"
            name="genderChoose"
            v-on:change="updateGender('Male')"
          />
          <label for="rbMale">Мужской</label>

          <input
            type="radio"
            id="rbFemale"
            name="genderChoose"
            v-on:change="updateGender('Female')"
          />
          <label for="rbFemale">Женский</label>

          <span class="input-error" v-if="this.genderError">{{
            this.genderError
          }}</span>
        </div>

        <div class="input-wrapper" v-if="this.isSmsCodeValidation">
          <p
            class="input-info input-sms-message"
            v-html="smsCodeMessage"
            v-if="this.smsCodeMessage"
          ></p>
          <input
            :class="'input-sms ' + { hasError: this.smsCodeError }"
            :value="smsCode"
            @input="updateSmsCode"
            v-on:keydown.enter.prevent="submitSmsCode"
            name="RegistrationForm[code]"
            placeholder=""
            v-mask="'#####'"
            type="text"
            :disabled="this.isRequested"
          />

          <span class="input-error" v-if="this.smsCodeError">{{
            this.smsCodeError
          }}</span>
        </div>

        <div class="input-wrapper" v-if="this.regErrors">
          <div
            class="input-error default-size"
            :key="idx"
            v-for="(error, idx) in this.regErrors"
          >
            <p v-html="error[0]"></p>
          </div>
        </div>

        <div class="input-wrapper" v-if="this.regError">
          <p class="input-error default-size" v-html="regError"></p>
        </div>

        <div class="input-wrapper" v-if="this.captchaError">
          <p class="input-error default-size">
            Ошибка прохождения Captcha. Пожалуйста, попробуйте
            зарегистрироваться еще раз
          </p>
        </div>

        <div class="input-wrapper isAccept-checkbox">
          <label>
            <input
              class="checkbox"
              type="checkbox"
              v-model="isAccept"
              v-on:change="validateIsAccept"
            />
            <p>
              Принимаю
              <a @click.prevent="openUserAgreement" href="#"
                >Пользовательское соглашение</a
              >
            </p>
          </label>
          <span class="input-error" v-if="this.isAcceptError">{{
            this.isAcceptError
          }}</span>
        </div>

        <div class="reg-form__footer">
          <input
            @click.prevent="submitSmsCode"
            v-on:keydown.enter.prevent="submitSmsCode"
            v-if="this.isSmsCodeValidation"
            class="basket-btn registration-btn registration-btn_small registration-btn_request"
            type="submit"
            value="Подтвердить код"
            data-toggle="modal"
            data-target="#regModal"
            :disabled="isRequested"
          />
          <input
            @click.prevent="submitReg"
            v-on:keydown.enter.prevent="submitReg"
            v-if="!this.isSmsCodeValidation"
            class="basket-btn registration-btn registration-btn_small registration-btn_request"
            type="submit"
            value="Зарегистрироваться"
            data-toggle="modal"
            data-target="#regModal"
            :disabled="isRequested || !isAccept"
          />
          <div class="block-loading" v-if="this.isRequested"></div>
          <input
            @click.prevent="hideForm()"
            class="basket-btn registration-btn registration-btn_small registration-btn_cancel"
            type="button"
            value="Отмена"
            :disabled="isRequested"
          />
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import { mask } from 'vue-the-mask';
import { setting } from '@/setting';
import { mapState } from 'vuex';
import { types } from '@/types';

export default {
  name: 'Registration',
  directives: { mask },
  props: ['disabled'],

  data() {
    return {
      regUrl: '',
      completeUrl: '',
      login: '',
      email: '',
      phone: '',
      birthday: '',
      password: '',
      repeatPassword: '',
      loginError: '',
      emailError: '',
      phoneError: '',
      birthdayError: '',
      passwordError: '',
      repeatPasswordError: '',
      regError: '',
      regErrors: [],
      isRequested: false,
      isAccept: false,
      smsCode: '',
      isSmsCodeValidation: false,
      smsCodeMessage: 'На Ваш номер телефона отправлен код подтверждения',
      smsCodeError: '',
      gender: '',
      genderError: '',
      captchaError: false,
      isAcceptError: '',
    };
  },

  computed: {
    ...mapState(['setting', 'theatre']),
  },

  created: function () {
    this.regUrl = setting.siteHost + '/registration';
    this.completeUrl = setting.siteHost + '/complete-registration';
  },

  methods: {
    openUserAgreement() {
      this.$modal.show('user-agreement');
      // this.resetForm();
    },
    updateLogin(e) {
      this.login = e.target.value;
      this.validateLogin();
    },

    updateEmail(e) {
      this.email = e.target.value;
      this.validateEmail();
    },

    updatePhone(e) {
      this.phone = e.target.value;
      this.validatePhone();
    },

    updateBirthday(e) {
      this.birthday = e.target.value;
      this.validateBirthday();
    },

    updatePassword(e) {
      this.password = e.target.value;
      this.validatePassword();
    },

    updateRepeatPassword(e) {
      this.repeatPassword = e.target.value;
      this.validateRepeatPassword();
    },

    updateGender(gender) {
      this.gender = gender;
      this.validateGender();
    },

    updateSmsCode(e) {
      this.smsCode = e.target.value;
      this.validateSmsCode();
    },

    validateLogin() {
      if (!this.login) {
        this.loginError = 'Необходимо заполнить Фамилию Имя Отчество';
        return false;
      }
      this.loginError = false;
      return true;
    },

    validateEmail() {
      if (!this.email) {
        this.emailError = 'Необходимо заполнить Email';
        return false;
      }
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email)) {
        this.emailError = 'Некорректный ввод Email';
        return false;
      }
      this.emailError = false;
      return true;
    },

    validatePhone() {
      if (!this.phone) {
        this.phoneError = 'Необходимо заполнить телефон';
        return false;
      }
      this.phoneError = false;
      return true;
    },

    validateBirthday() {
      if (!this.birthday) {
        this.birthdayError = 'Необходимо заполнить дату рождения';
        return false;
      }

      this.birthdayError = false;
      return true;
    },

    validateLengthBirthday() {
      const date = this.birthday.split('.');
      if (date.length < 3 || date[2].length < 4) {
        this.birthdayError =
          'Дату рождения необходимо заполнить в виде ДД.ММ.ГГГГ';
        return false;
      }

      this.birthdayError = false;
      return true;
    },

    validatePassword() {
      if (!this.password) {
        this.passwordError = 'Необходимо заполнить пароль';
        return false;
      }

      this.passwordError = false;
      return true;
    },

    validateLengthPassword() {
      if (this.password.length < 6) {
        this.passwordError = 'Пароль должен содержать не менее 6 символов';
        return false;
      }

      this.passwordError = false;
      return true;
    },

    validateRepeatPassword() {
      if (!this.repeatPassword) {
        this.repeatPasswordError = 'Необходимо еще раз написать пароль';
        return false;
      }
      this.repeatPasswordError = false;
      return true;
    },

    validateGender() {
      if (!this.gender) {
        this.genderError = 'Необходимо выбрать пол';
        return false;
      }

      this.genderError = false;
      return true;
    },

    validateIsAccept() {
      if (!this.isAccept) {
        this.isAcceptError = 'Необходимо принять пользовательское соглашение';
        return false;
      }

      this.isAcceptError = false;
      return true;
    },

    validateSmsCode() {
      if (this.isSmsCodeValidation) {
        if (!this.smsCode) {
          this.smsCodeError = 'Необходимо указать код из СМС';
          return false;
        }
      }
      this.smsCodeError = false;
      return true;
    },

    validateForm(e) {
      this.validateLogin();
      this.validateEmail();
      this.validatePhone();
      this.validateBirthday();
      this.validateLengthBirthday();
      this.validatePassword();
      this.validateLengthPassword();
      this.validateRepeatPassword();
      this.validateGender();
      this.validateIsAccept();
      this.validateSmsCode();
      if (!this.isFormFilledCorrectly()) {
        e.preventDefault();
        return false;
      }
      return true;
    },

    clearErrors() {
      this.loginError = '';
      this.emailError = '';
      this.phoneError = '';
      this.birthdayError = '';
      this.passwordError = '';
      this.repeatPasswordError = '';
      this.regError = '';
      this.regErrors = [];
      this.smsCodeError = '';
      this.genderError = '';
      this.isAcceptError = '';
    },

    resetForm() {
      this.clearErrors();

      this.login = '';
      this.email = '';
      this.phone = '';
      this.birthday = '';
      this.password = '';
      this.repeatPassword = '';
      this.isRequested = false;
      this.smsCode = '';
      this.isSmsCodeValidation = false;
      this.smsCodeMessage = '';
      this.gender = '';
      this.isAcceptError = '';
    },

    async submitSmsCode() {
      const smsCodeData = await this.$store.dispatch('sendSMSCode', {
        MobilePhone: this.phone.replace(/\s|-|\(|\)/gi, ''),
        Code: this.smsCode,
        theatreId: this.$route.params.theatreId,
        setCookies: this.$cookie.set,
      });

      console.log(smsCodeData, 'smsCodeData');

      if (smsCodeData.success) {
        this.hideForm();
      }

      if (smsCodeData.error) {
        this.authError = smsCodeData.error;
      }
    },

    async submitReg(e) {
      this.captchaError = false;
      if (!this.validateForm(e)) return;

      const checkReCaptcha = async () => {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('registration');
        const answer = await this.$store.dispatch('getStatusReCaptcha', {
          token,
        });
        return answer.Success;
      };

      if (!(await checkReCaptcha())) {
        this.captchaError = true;
        return;
      }

      this.clearErrors();

      let CrmSystemIdList = [];

      if (this.theatre.CrmSystemId)
        CrmSystemIdList = [this.theatre.CrmSystemId];

      const registrationStatus = await this.$store.dispatch('registration', {
        Password: this.password,
        CityId: this.theatre.CityId,
        CrmSystemIdList,
        TheatreId: this.$route.params.theatreId,
        MobilePhone: this.phone,
        Email: this.email,
        FullName: this.login,
        Birthday: this.birthday,
        Gender: this.gender,
      });

      if (registrationStatus.success) {
        this.isSmsCodeValidation = true;
        this.$store.commit(types.USER_REGISTRATION_FROM_WIDGET);
      } else {
        this.regError = registrationStatus.error;
        console.log(registrationStatus, registrationStatus.error);
      }
    },

    isFormFilledCorrectly() {
      return (
        this.login &&
        this.email &&
        this.phone &&
        this.birthday &&
        this.password &&
        this.repeatPassword &&
        this.gender &&
        !(
          this.loginError ||
          this.emailError ||
          this.phoneError ||
          this.birthdayError ||
          this.passwordError ||
          this.repeatPasswordError ||
          this.genderError
        ) &&
        (this.isSmsCodeValidation ? this.smsCode && !this.smsCodeError : true)
      );
    },

    hideForm() {
      this.$modal.hide('registration-form');
      this.resetForm();
    },
  },
};
</script>

<style lang="scss">
.registration-modal .v--modal-box.v--modal {
  position: relative !important;
  width: auto !important;
  min-width: 200px !important;
  max-width: calc(90vw - 30px) !important;
  min-height: 200px !important;
  height: auto !important;
  max-height: calc(90vh - 30px) !important;
  padding: 10px !important;
  z-index: 99999 !important;
  display: block;
}

.reg {
  margin: 0 !important;
  padding: 15px !important;
  height: 100% !important;

  &-form {
    width: 100%;
    max-width: 400px;
    flex-direction: column;

    &__header {
      font-size: 20px;
      text-align: center;
      color: #ffffff;
      margin-top: 20px;
      margin-bottom: 20px;
    }

    &__footer {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      position: relative;
    }
  }

  &.step-box {
    position: relative;
    border: none;

    .input-wrapper {
      .input-sms {
        width: 100px;
        margin: 0 auto;
        display: block;
      }

      &.gender {
        border: none;
        outline: none;
        border-radius: 25px;
        padding: 10px 20px;
        font-size: 18px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%;
        border: 2px solid transparent;
      }
    }

    .input-error {
      color: white !important;
      margin: 10px 0;
      font-size: 14px !important;

      a {
        color: white;
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}

.registration-btn {
  &_request {
    width: 100%;
    margin: 0 20px 0 0;
  }

  &_small {
    height: 45px;
    border: none;
    text-transform: none;
    border-radius: 8px;

    &:focus {
      outline: none;
    }
  }
}

.basket-btn_alt_close {
  position: absolute;
  top: -5px;
  right: 5px;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  background: transparent;
  border: 1px solid #ccc;
  transform: rotate(45deg);
}

.basket-btn_alt_close::before,
.basket-btn_alt_close::after {
  position: absolute;
  left: 22px;
  content: ' ';
  height: 24px;
  width: 2px;
  background-color: #ccc;
  top: 10px;
}

.basket-btn_alt_close::before {
  transform: rotate(45deg);
}

.basket-btn_alt_close:hover {
  opacity: 1;
}

.input-info.input-sms-message {
  text-align: left;
  padding: 10px 0 15px 0;
}

.reg {
  .pz-close-btn {
    top: 10px;
    right: 10px;
  }
}

.v--modal-overlay .v--modal-box {
  overflow: auto !important;
  height: auto !important;
}

.isAccept-checkbox {
  label {
    display: flex;
    align-items: center;
    justify-content: center;

    .checkbox {
      width: 1rem;
      height: 1rem;
      margin-right: 0.5rem;
    }

    p {
      margin: 0;
      font-size: 0.9rem;
      opacity: 0.9;

      a {
        color: rgba(255, 255, 255, 0.7);
        text-decoration: underline;
      }
    }
  }
}

@media only screen and (max-width: 768px),
  only screen and (max-width: 768px) and (max-height: 650px) {
  .registration-modal .v--modal-box.v--modal {
    position: relative !important;
    width: auto !important;
    min-width: 200px !important;
    max-width: calc(90vw - 30px) !important;
    min-height: 200px !important;
    height: auto !important;
    max-height: calc(90vh - 30px) !important;
    padding: 10px !important;
    z-index: 99999 !important;
    display: block;
  }
}

@media only screen and (max-width: 480px) {
  .registration-modal .reg-modal .v--modal {
    position: relative !important;
    width: auto !important;
    min-width: 200px !important;
    max-width: calc(90vw - 30px) !important;
    height: auto !important;
    min-height: 200px;
    max-height: calc(90vh - 30px) !important;
    padding: 10px !important;
    z-index: 99999 !important;
    display: block;

    &-form {
      width: 100% !important;
    }
  }

  .reg {
    width: calc(100% - 30px);
    padding-top: 0 !important;

    &-form {
      width: auto !important;
      min-width: auto !important;
    }
  }

  .reg-form__footer {
    flex-direction: column !important;

    .registration-btn_cancel {
      display: none;
    }
  }
}

@media only screen and (max-height: 630px) {
  .registration-modal .v--modal-box.v--modal {
    position: relative !important;
    height: auto !important;
    min-height: 180px;
    max-height: calc(90vh - 30px) !important;
    padding: 10px !important;
    z-index: 99999 !important;
    display: block;
  }
}
</style>
